import { useEffect, useRef, useState } from 'react'
import classNames from 'classnames'

// import Card from '../ui/Card/Card'
import Image from '../ui/Image/Image'
import { useLanguage } from '../../context/LangaugeContextProvider/LangaugeContextProvider'
import useIsMobile from '../../hooks/useIsMobile'
import { getImageUrl, isArabic, updateClassname } from '../../utils'

import styles from './UpiLayout.module.scss'

function PillarsSection({
  title,
  pillarsCards = [],
  backgroundImage,
  pillarsSectionClass,
}) {
  const { language } = useLanguage()
  const targetRef = useRef(null)
  const childRef = useRef(null)
  const lastScrollY = useRef(0)
  const [isAtTop, setIsAtTop] = useState(false)
  const isVisible = useRef(false)
  const disableClassname = 'scroll-disabled'
  const isMobile = useIsMobile()

  function isOverlapped(element) {
    const rect = element.getBoundingClientRect()
    const centerX = rect.left + rect.width / 2
    const bottomY = rect.bottom - 1
    const bottomElement = document.elementFromPoint(centerX, bottomY)

    return bottomElement !== element && !element.contains(bottomElement)
  }

  useEffect(() => {
    const targetElement = targetRef.current
    const childContainer = childRef.current
    const visibilityElement = isMobile
      ? childContainer?.lastElementChild
      : targetElement

    const handleScroll = () => {
      if (targetElement && childContainer) {
        const element = childContainer.lastElementChild
        const style = element ? window?.getComputedStyle(element) : {}

        const visible =
          style?.display !== 'none' &&
          style?.visibility !== 'hidden' &&
          parseFloat(style?.opacity) > 0
        if (visible && !isOverlapped(visibilityElement)) {
          isVisible.current = true
        } else {
          isVisible.current = false
        }
        const rect = targetElement.getBoundingClientRect()
        if (rect.top <= 0) {
          if (!isAtTop) {
            setIsAtTop(true)
            lastScrollY.current = window.scrollY
            updateClassname('add', document.body, disableClassname)
          }
        } else {
          if (isAtTop) {
            setIsAtTop(false)
            updateClassname('remove', document.body, disableClassname)
          }
        }
      }
    }

    const handleChildScroll = (event) => {
      const tolerance = 1
      const bottom =
        childContainer.scrollTop + childContainer.clientHeight >=
        childContainer.scrollHeight - tolerance
      const top = childContainer.scrollTop === 0
      if (isAtTop) {
        if ((bottom && event.deltaY > 0) || (top && event.deltaY < 0)) {
          updateClassname('remove', document.body, disableClassname)
        } else if (bottom && event.deltaY < 0 && !isVisible.current) {
          updateClassname('add', childContainer, disableClassname)
          updateClassname('remove', document.body, disableClassname)
        } else {
          updateClassname('add', document.body, disableClassname)
          childContainer.scrollTop += event.deltaY
          event.preventDefault()
        }
      } else if (!isAtTop) {
        if (!top && event.deltaY < 0) {
          setIsAtTop(true)
          updateClassname('remove', childContainer, disableClassname)
          updateClassname('add', document.body, disableClassname)
          childContainer.scrollTop += event.deltaY
          event.preventDefault()
        }
      }
    }

    const keyDown = (e) => {
      if (e.keyCode === 38 || e.keyCode === 40) {
        updateClassname('remove', document.body, disableClassname)
      }
    }

    // window.addEventListener('scroll', handleScroll)
    // window.addEventListener('wheel', handleChildScroll, { passive: false })
    // window.addEventListener('keydown', keyDown)

    return () => {
      // window.removeEventListener('scroll', handleScroll)
      // window.removeEventListener('wheel', handleChildScroll)
      // window.removeEventListener('keydown', keyDown)
    }
  }, [isAtTop])

  return (
    <div
      className={classNames(styles.pillarsSection, pillarsSectionClass)}
      // style={{ backgroundImage: `url(${getImageUrl(backgroundImage)})` }}
      ref={targetRef}
    >
      <div
        className={classNames(styles.backgroundImageContainer, {
          [styles.arabicBackgroundImageContainer]: isArabic(language?.code),
        })}
      >
        <Image src={getImageUrl(backgroundImage)} />
      </div>
      <div className={styles.pillarsInnerContainer}>
        <div className={styles.headerContainer}>
          <h1>{title}</h1>
        </div>
        {/* <div ref={childRef} className={styles.cardsContainer}>
          {pillarsCards.map((pillar, index) => (
            <Card
              key={'pillar' + pillar?.id}
              className={classNames(styles.pillarCard)}
            >
              <div className={styles.cardNumber}>{index + 1}</div>
              <div className={styles.cardContent}>
                <h2>{pillar.heading}</h2>
                <p>{pillar.description}</p>
              </div>
            </Card>
          ))}
        </div> */}
      </div>
    </div>
  )
}

export default PillarsSection
